module.exports = __webpack_public_path__ + "static/media/check.c5c4b662.svg";